import { render, staticRenderFns } from "./ldbz.vue?vue&type=template&id=1a10fe96&scoped=true"
import script from "./ldbz.vue?vue&type=script&lang=js"
export * from "./ldbz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10fe96",
  null
  
)

export default component.exports